import * as THREE from 'three';
import { TOPICS } from '../data/topics.js';

const tmpVec = new THREE.Vector3();

export function buildLabels(islandObjects) {
  islandObjects.forEach(o => {
    const topic = TOPICS[o.project.topic];
    const label = document.createElement('div');
    label.className = 'island-label' + (o.project.featured ? ' featured' : '');
    label.innerHTML = `<span class="topic" style="color:${topic.hex}">${topic.name}</span><span class="name">${o.project.name}</span>`;
    document.body.appendChild(label);
    o.label = label;
  });
}

export function updateLabels(islandObjects, camera, activeTopic) {
  islandObjects.forEach(o => {
    tmpVec.set(0, 0, 0);
    o.mesh.getWorldPosition(tmpVec);
    tmpVec.y += 40;
    tmpVec.project(camera);
    const inView = tmpVec.z < 1 && tmpVec.x > -1.05 && tmpVec.x < 1.05 && tmpVec.y > -1.05 && tmpVec.y < 1.05;
    if (!inView) {
      o.label.style.opacity = '0';
      return;
    }
    const px = (tmpVec.x + 1) / 2 * window.innerWidth;
    const py = (-tmpVec.y + 1) / 2 * window.innerHeight;
    o.label.style.left = px + 'px';
    o.label.style.top = py + 'px';
    const dist = camera.position.distanceTo(o.mesh.position);
    const match = activeTopic === 'all' || o.project.topic === activeTopic;
    const distOpacity = Math.max(0, Math.min(1, (1400 - dist) / 700));
    o.label.style.opacity = (match ? distOpacity : distOpacity * 0.16).toFixed(2);
  });
}
